/** The editor's left side: the toolbox, its tabs (Add, Outline, Data), and the Data pane. */
export const toolbox = {
  find: 'Find a field or a kind',
  nothing: 'Nothing by that name.',
  addAField: 'Add a field',
  addNew: (kind: string) => `${kind}: add a new field`,
  fromTheModel: 'From the model',
  inTheModel: (label: string, stored: string) => `${label}: already in the model, stored as ${stored}`,
  layout: 'Layout',
  tabs: 'Tabs',
  tabsTip: 'Tabs: pages of sections on a record sheet',
  section: 'Section',
  sectionTip: 'Section: a titled group of fields',
  /** Advanced's layout tiles: a name, and what it is. */
  blocks: {
    group: ['Group', 'A titled group, with its own columns'],
    side: ['Side by side', 'Two groups next to each other'],
    tabs: ['Tabs', 'Pages of groups, one shown at a time'],
    heading: ['Heading', 'A title between parts'],
    text: ['Text', 'A paragraph or a note'],
    divider: ['Divider', 'A line across'],
    spacer: ['Spacer', 'Room, or an empty cell'],
    image: ['Image', 'A picture or a logo'],
    button: ['Button', 'Send, or another action'],
    map: ['Map', 'The record’s places, a route between them, the reader’s own place'],
  } as Record<'group' | 'side' | 'tabs' | 'heading' | 'text' | 'divider' | 'spacer' | 'image' | 'button' | 'map', readonly [name: string, tip: string]>,
  blockTip: (name: string, tip: string) => `${name}: ${tip}`,
  // ---- the rail's tabs
  add: 'Add',
  outline: 'Outline',
  data: 'Data',
  besideThePage: 'Beside the page',
  railLabel: 'Add, outline and data',
  // ---- where the toolbox cannot sit beside the page: in a sheet, behind a +
  openToolbox: 'Open the toolbox',
  closeToolbox: 'Close the toolbox',
  // ---- the Data pane
  responses: 'Answers are kept as responses:',
  responsesModel: 'one record per person, one field per question',
  surveyFields: 'A survey makes its own fields: each question added is a new one, so every kind is offered.',
  addAsColumn: 'Add as a column',
  addField: 'Add',
  onThePage: 'On the page',
  notUsed: 'Not used',
  storedTitle: (label: string, stored: string) => `${label}: ${stored}`,
  recordOnCanvas: 'Record on the canvas',
  empty: 'Empty',
  record: (n: number) => `Record ${n}`,
  madeUp: 'A made-up record fills the page, so it reads as it will with real ones. Nothing here is saved.',
  listShows: 'This list shows records of',
  pageShows: 'This page shows records of',
  fieldCount: (all: number, onPage: number) => `${all} fields · ${onPage} on this page`,
};
